export default {
  init() {
    // JavaScript to be fired on all pages
    $('#main-nav .menu-item-has-children > a').on('click', function(){
      if($(this).parent().hasClass('open')){ //Need to close this menu
        $(this).parent().removeClass('open');
        $(this).parent().find('.sub-menu').removeClass('open');
      }else{ //Need to open this menu and close other menus if they are open
        $('#main-nav .menu-item-has-children').removeClass('open');
        $('#main-nav .sub-menu').removeClass('open');

        $(this).parent().addClass('open');
        $(this).parent().find('.sub-menu').addClass('open');
      }
      return false;
    });

    //Manipulate wpcf7 inputs for correct behaviour
    $('.wpcf7-form .styled').each(function(i, el){
      console.log(el);
      let $label = $(el).find('label');
      $(el).find('input, textarea').prop('required', true);
      let $container = $(el).find('input, textarea').parents('.wpcf7-form-control-wrap');
      $container.addClass('styled-input');
      $label.appendTo($container);
      $container.append('<span></span>');
    });

    let ac_options = {
      componentRestrictions: {country: 'uk'},
    };
    let ac_input = document.getElementById('address_lookup');
    // eslint-disable-next-line no-unused-vars, no-undef
    let ac = new google.maps.places.Autocomplete(ac_input, ac_options);
    ac.addListener('place_changed', () => {
      let place = ac.getPlace();
      let lat = place.geometry.location.lat();
      let lng = place.geometry.location.lng();

      let url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+lat+','+lng+'&key=AIzaSyDsgiTgfJcg2ZlPMlrZOmxcuIp4KpENjfg';
      console.log(url);

      let data = {
        lon: lng,
        lat: lat,
      };

      $.ajax({
        url: 'https://api.postcodes.io/postcodes',
        data: data,
        success: function(data){
          if(data.status===200){
            console.log(data.result[0]);
            let info = data.result[0];
            let text = '';
            text+= '<strong>Admin County: </strong>' + info.admin_county + '<br/>';
            text+= '<strong>Admin District: </strong>' + info.admin_district + '<br/>';
            text+= '<strong>Admin Ward: </strong>' + info.admin_ward + '<br/>';
            text+= '<strong>CCG: </strong>' + info.ccg + '<br/>';
            text+= '<strong>CED: </strong>' + info.ced + '<br/>';
            text+= '<strong>European Electoral Region: </strong>' + info.european_electoral_region + '<br/>';
            text+= '<strong>NHS HA: </strong>' + info.nhs_ha + '<br/>';
            text+= '<strong>Parish: </strong>' + info.parish + '<br/>';
            text+= '<strong>Parlimentary Constituency: </strong>' + info.parliamentary_constituency + '<br/>';
            text+= '<strong>Primary Care Trust: </strong>' + info.primary_care_trust + '<br/>';
            text+= '<strong>Region: </strong>' + info.region + '<br/>';

            $('#local_info').html(text);
          }
        },
        dataType: 'json',
      });

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js